import { Component, ElementRef, HostListener, inject } from '@angular/core';

@Component({
  selector: 'app-menu-logos-movil',
  imports: [],
  templateUrl: './menu-logos-movil.html',
  styleUrl: './menu-logos-movil.scss',
})
export class MenuLogosMovil  {
  private eRef = inject(ElementRef);

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (typeof document === 'undefined') return;

    const spanSities = document.getElementsByClassName('sities')[0] as HTMLElement;
    const svgSities = document.getElementById('Componente_2_1');
    const spanSitiesNav = document.getElementsByClassName('sitiesNav')[0] as HTMLElement;
    const svgSitiesNav = document.getElementById('Componente_2_1Nav');

    const target = event.target as HTMLElement;

    if (
      !this.eRef.nativeElement.contains(target) &&
      target !== spanSities &&
      target !== svgSities &&
      target !== spanSitiesNav &&
      target !== svgSitiesNav
    ) {
      const box = document.getElementById('menuCompanies');

      if (spanSities?.classList.contains('open')) {
        box!.style.display = 'none';
        spanSities.classList.remove('open');
      }
    }
  }

  closeMenu() {
    if (typeof document !== 'undefined') {
      const display = document.getElementById('menuCompanies');
      display!.style.display = 'none';
    }
  }
}
